import React from "react";
import * as echarts from "echarts/core";
// import ReactEcharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import { GaugeChart } from "echarts/charts";

const Gauge = (props) => {
    echarts.use([GaugeChart]);
    const getOption = {
        grid: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        },
        series:
        {
            type: 'gauge',
            max: props.gaugeMax,
            progress: {
                show: true,
                width: 9,
                itemStyle: {
                    color: props.color
                }
            },
            axisLine: {
                lineStyle: {
                    color: [[1, '#1C2F59']],
                    width: 9
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLabel: {
                show: false
            },
            anchor: {
                show: false,
            },
            pointer: {
                show: false
            },
            title: {
                show: false
            },
            detail: {
                color: '#fff',
                offsetCenter: [0, 5],
                fontSize: 28,
                fontWeight: 700
            },
            data: [
                {
                    value: props.data
                }
            ]
        }
    }
    return (
        <>
            <ReactEChartsCore
                echarts={echarts}
                style={{
                    height: '100%',
                    width: '100%',
                }}
                option={getOption}
            />
        </>
    );
};

export default Gauge